import { combineReducers } from 'redux';

import { SET_TASK_FILTERS, RESET_TASK_FILTERS, SET_TASK_GRID_SORT_CRITERIA } from './actionTypes';

const taskFiltersInitialState = {
  aggregatorID: '',
  payerID: '',
};

const taskGridSortCriteriaInitialState = {
  sortByColumn: '',
  sortDirection: '',
};

const taskFiltersReducer = (
  state = taskFiltersInitialState,
  { type = '', filters = { ...taskFiltersInitialState } } = {},
) => {
  switch (type) {
    case SET_TASK_FILTERS:
      return {
        ...state,
        ...filters,
      };

    case RESET_TASK_FILTERS:
      return {
        ...state,
        ...taskFiltersInitialState,
      };

    default: {
      return state;
    }
  }
};

const currentTaskGridSortCriteriaReducer = (
  state = taskGridSortCriteriaInitialState,
  { type = '', sortCriteria = { ...taskGridSortCriteriaInitialState } } = {},
) => {
  switch (type) {
    case SET_TASK_GRID_SORT_CRITERIA:
      return {
        ...state,
        ...sortCriteria,
      };

    default:
      return state;
  }
};

const taskReducer = combineReducers({
  taskFilters: taskFiltersReducer,
  taskGridSortCriteria: currentTaskGridSortCriteriaReducer,
});

export { taskReducer, taskFiltersInitialState, taskGridSortCriteriaInitialState };
